import React from "react";
import withStyles from '@mui/styles/withStyles';
import Tooltip from "@mui/material/Tooltip";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

const useStyles = () => ({
    badge: {
        color: '#FFB300',
        fontSize: '0.95rem',
        verticalAlign: 'middle',
        filter: 'drop-shadow(0 1px 2px rgba(255, 179, 0, 0.4))',
        marginLeft: 2,
    },
});

function PersonalRecordBadge({classes, prType}) {
    const label = prType ? `Personal Record — ${prType.charAt(0).toUpperCase() + prType.slice(1)}` : 'Personal Record';

    return (
        <Tooltip title={label} arrow placement="top">
            <EmojiEventsIcon className={classes.badge} fontSize="small"/>
        </Tooltip>
    );
}

export default withStyles(useStyles)(PersonalRecordBadge);
